import { Box, FlexColumn, OverflowText } from "designSystem/index";
import DojoView from "csi/page/DojoView";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React from "react";
import { useMassUpdateBOMWizardStore } from "csi/store/MassUpdateWizardStore";

export const MassUpdateLinkedBOMsTable = observer(() => {
	const store = useMassUpdateBOMWizardStore();
	const { revisionParentUrl, tableNodeType, tableSubTitleRes, tableViewId, viewParams } = store;

	return (
		<FlexColumn p={5}>
			<Box mb={1.5}>
				<OverflowText res={tableSubTitleRes} />
			</Box>
			<Box growNoOverflow>
				<DojoView 
					fullHeight 
					nodeUrl={revisionParentUrl} 
					viewId={tableViewId} 
					viewNodeType={tableNodeType}
					viewParams={viewParams}
				/>
			</Box>
		</FlexColumn>
	);
});
